/**
 * The dashboard counter. Counts up once on load and never again — the only
 * motion on the screen besides sheets sliding up.
 *
 * Honours prefers-reduced-motion by jumping straight to the final value.
 */

import { useEffect, useState } from 'react';

const DURATION_MS = 700;

export function useCountUp(target) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setValue(target);
      return;
    }

    let frame = 0;
    const start = performance.now();

    const step = (now) => {
      const progress = Math.min(1, (now - start) / DURATION_MS);
      // Ease-out cubic: fast off the line, settles gently.
      const eased = 1 - (1 - progress) ** 3;
      setValue(Math.round(target * eased));
      if (progress < 1) frame = requestAnimationFrame(step);
    };

    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [target]);

  return value;
}
